import React from 'react'
import style from "css/app.module.css"

/**
 * 파일명: Container.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: app Container
 */
function Container({ children }) {
    return (
        <div className={style.main_container}>
            {children}
        </div>
    )
}

export default Container
